export const scrollToBlock = (blockClass: string) => {
	const block = document.querySelector(`.${blockClass}`) as HTMLElement;
	if (block) {
		block.scrollIntoView({ behavior: 'smooth' });
	}
};